import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  private noteList = new BehaviorSubject<any[]>([]);
  notes$ = this.noteList.asObservable(); // Expose tasks as observable

  constructor(
    private localStorage: LocalStorageService
  ) {}

  setTasks(newTasks: any[]) {
    this.noteList.next(newTasks);
  }

  addTask(newTask: any) {
  
    let newTaskObj:any = {
        name: this.localStorage.getProfileName(),
        date: moment(newTask.updatedAt).format('DD/MM/YYYY HH:mm'),
        desc: newTask.note_name,
        id: newTask.id
    }

    this.noteList.next([ newTaskObj, ...this.noteList.value]);
  }

}
